(() => {
  "use strict";
  const KEY = "nj_saved_routine_v1";
  const path = window.Shopify?.routes?.root || "/";
  const root = path.endsWith("/") ? path : path + "/";
  const get = sel => document.querySelector(sel);
  const all = sel => [...document.querySelectorAll(sel)];
  const dialog = get("[data-nj-saved-dialog]");
  if (!dialog) return;
  const status = get("[data-nj-saved-status]");
  const safeRead = () => {
    try {
      const data = JSON.parse(window.localStorage.getItem(KEY) || "null");
      if (!data || data.version !== 1 || !Array.isArray(data.items) || data.items.length < 1 || data.items.length > 6) return null;
      if (!data.items.every(x => typeof x.handle === "string" && /^[a-z0-9-]{3,180}$/.test(x.handle) && Number.isSafeInteger(x.variantId) && x.variantId > 0 && Number.isSafeInteger(x.quantity) && x.quantity >= 1 && x.quantity <= 99)) return null;
      return data;
    } catch (_) { return null; }
  };
  const safeSave = data => {
    try { window.localStorage.setItem(KEY, JSON.stringify(data)); return true; }
    catch (_) { return false; }
  };
  function sync() {
    const exists = Boolean(safeRead());
    all("[data-nj-saved-open]").forEach(b => b.hidden = !exists);
    all("[data-nj-saved-entry]").forEach(b => b.hidden = !exists);
  }
  const fmt = cents => {
    try { return new Intl.NumberFormat("es-ES", { style: "currency", currency: window.Shopify?.currency?.active || "EUR" }).format(cents / 100); }
    catch (_) { return (cents / 100).toFixed(2) + " €"; }
  };
  const productUrl = handle => root + "products/" + encodeURIComponent(handle);
  async function fetchProduct(handle) {
    const r = await fetch(productUrl(handle) + ".js", { headers: { Accept: "application/json" } });
    if (!r.ok) throw new Error("Sin producto");
    return r.json();
  }
  let selection = [];
  function update() {
    const checked = selection.filter(x => x.available && x.checkbox?.checked);
    const total = checked.reduce((sum, x) => sum + Number(x.variant.price) * x.quantity, 0);
    get("[data-nj-saved-total]").textContent = fmt(total);
    const add = get("[data-nj-saved-add]");
    add.disabled = !checked.length || Boolean(add.dataset.busy);
    add.textContent = checked.length ? "Añadir " + checked.reduce((n, x) => n + x.quantity, 0) + " productos al carrito" : "Ningún producto seleccionado";
    return checked;
  }
  async function openSaved() {
    const saved = safeRead();
    if (!saved) { sync(); return; }
    const list = get("[data-nj-saved-list]");
    list.replaceChildren();
    status.textContent = "Comprobando precios y existencias…";
    get("[data-nj-saved-add]").disabled = true;
    if (!dialog.open) dialog.showModal();
    const products = await Promise.all(saved.items.map(async (item) => {
      try {
        const p = await fetchProduct(item.handle);
        const v = p.variants?.find(x => Number(x.id) === item.variantId);
        return { item, product: p, variant: v, available: !!(p.available && v?.available && Number(v.price) > 0) };
      } catch (_) { return { item, product: null, variant: null, available: false }; }
    }));
    if (!dialog.open) return;
    selection = [];
    for (const x of products) {
      const row = document.createElement("div"); row.className = "nj-saved-dialog__item";
      const input = document.createElement("input"); input.type = "checkbox"; input.checked = x.available; input.disabled = !x.available;
      input.setAttribute("aria-label", "Incluir " + (x.product?.title || x.item.handle)); input.addEventListener("change", update);
      row.append(input);
      const imageLink = document.createElement("a"); imageLink.href = productUrl(x.item.handle);
      let src = x.product?.featured_image || x.product?.images?.[0];
      if (src && typeof src === "object") src = src.src;
      if (typeof src === "string" && /^(https?:)?\/\//.test(src)) {
        const img = document.createElement("img"); img.src = src; img.alt = x.product.title; img.loading = "lazy"; imageLink.append(img);
      }
      row.append(imageLink);
      const desc = document.createElement("div"); desc.className = "nj-saved-dialog__description";
      const title = document.createElement("a"); title.href = productUrl(x.item.handle); title.textContent = x.product?.title || "Producto no disponible"; desc.append(title);
      const sub = document.createElement("small");
      sub.textContent = x.available ? x.item.quantity + " × " + fmt(Number(x.variant.price)) : "No disponible actualmente";
      desc.append(sub); row.append(desc); list.append(row);
      selection.push({ checkbox: input, variant: x.variant, quantity: x.item.quantity, available: x.available });
    }
    status.textContent = products.some(x => !x.available) ? "Algunos productos no están disponibles. Puedes añadir los demás." : "";
    update();
  }
  document.addEventListener("click", async e => {
    const save = e.target.closest("[data-nj-routine-save]");
    if (save) {
      const box = save.closest("[data-nj-pdp-upsell]");
      const statusHere = box?.querySelector("[data-nj-routine-status]");
      let items = [];
      try { items = JSON.parse(box?.dataset.njCurrentSelection || "[]"); } catch (_) {}
      if (!items.length) { if(statusHere) statusHere.textContent = "Selecciona primero el formato del producto."; return; }
      if (safeSave({ version: 1, savedAt: new Date().toISOString(), items })) {
        if (statusHere) statusHere.textContent = "Rutina guardada en este navegador. Podrás reponerla desde el carrito.";
        sync();
      } else if(statusHere) { statusHere.textContent = "Tu navegador no permite guardar la rutina."; }
      return;
    }
    if (e.target.closest("[data-nj-saved-open]")) { e.preventDefault(); await openSaved(); return; }
    if (e.target.closest("[data-nj-saved-close]")) { dialog.close(); return; }
    if (e.target.closest("[data-nj-saved-clear]")) {
      try { window.localStorage.removeItem(KEY); } catch (_) {}
      selection = []; dialog.close(); sync(); return;
    }
    if (e.target.closest("[data-nj-saved-add]")) {
      const add = get("[data-nj-saved-add]"); if (add.dataset.busy) return;
      const products = update();
      if (!products.length) { status.textContent = "Selecciona al menos un artículo disponible."; return; }
      add.dataset.busy = "true"; add.disabled = true; status.textContent = "Añadiendo artículos…";
      const items = products.map(x => ({ id: Number(x.variant.id), quantity: x.quantity }));
      try {
        const r = await fetch(root + "cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items }) });
        if (!r.ok) throw new Error("No se pudo añadir la selección");
        window.location.assign(root + "cart");
      } catch (_) {
        status.textContent = "No se pudo añadir la selección. Comprueba las existencias y vuelve a intentarlo.";
        delete add.dataset.busy; update();
      }
    }
  });
  dialog.addEventListener("click", e => { if (e.target === dialog) dialog.close(); });
  sync();
})();